import { map } from 'mobx';
export default function initializeInboxRulesEditState() {
    return {
        ruleId: '',
        ruleName: '',
        conditionalClauseIds: [],
        actionClauseIds: [],
        exceptionClauseIds: [],
        clauseMap: map({}),
        clauseErrorTextMap: map({}),
        includesWordsInputTextMap: map({}),
        isSectionInfoCalloutVisible: map({}),
        focusedClauseId: '',
        ignoreSubsequentRules: true,
        shouldRunRuleNow: false,
        selectedFolderId: '',
        shouldShowMoveToDropdown: true,
    };
}
//# sourceMappingURL=initializeInboxRulesEditState.js.map